const RouteConstants = {
  HOME: "/",
  MANAGE_USERS: "/manageusers",
  GAME_AUDIT: "/audit/game",
  TEAM_BALLOT_DASHBOARD: "/teamballotdashboard",
  TEAM_GREEN_BALLOT_VOTE: "/teamgreenballotdashboard",
  ADMIN_BALLOT_DASHBOARD: "/adminballotdashboard",
  MANAGEMENT_PERMISSION: "/managepermission",
  ADMIN_PREFERENCES: "/adminpreferences",
  PLAYER_LIST: "/player/list",
  EDIT_PLAYER_PROFILE: "/edit/playerprofile",
  VIEW_PLAYER_PROFILE: "/player/view",
  MANAGE_PLAYER_CAREER_STATS: "/manageplayercareerstats",
  COMPARE_PLAYER_STATS: "/compare-player-stats",
  LOGIN: "/login",
  LOGOUT: "/logout",
  UNAUTHORIZED: "/Unauthorized",
  COMBINE_RESULTS: "/combine/results",
  COMPARE_PLAYERS: "/compare/players",
  CAREER_STATS: "/dashboard/stats",
  USER_PREFERENCES: "/userpreferences",
  REVISED_GAME_AUDIT: "/revised/audit/game",
  BOX_SCORE: "/box/score",
  MANAGE_EMAIL_NOTIFICATION: "/manage/email-notification",
  EMAIL_NOTIFICATION: "/email/notification",
  VIEW_EMAIL_NOTIFICATION: "/view/email-notification",
  TEAM_TOP_FIVE_BALLOT_VOTE: "/ballot/team-top-five-players-dashboard",
  MANAGE_TEAM_PLAYERS: "/manage/team-players",
  EVENT_SCHEDULER: "/event/scheduler",
  VIEW_TEAM_ROSTER: "/team-rosters",
  USER_MANAGEMENT: "/manage/users",
  FIVE_ON_FIVE_MANAGEMENT: "/manage/5on5games",
};

export default RouteConstants;
